// extracted by mini-css-extract-plugin
export var activeIndex = "FaqSchemaSection-module--activeIndex--dc52e";
export var btn = "FaqSchemaSection-module--btn--29980";
export var buttonQues = "FaqSchemaSection-module--buttonQues--93dae";
export var buttons = "FaqSchemaSection-module--buttons--90eb9";
export var cMarginTop = "FaqSchemaSection-module--c-margin-top--34515";
export var cPadding = "FaqSchemaSection-module--c-padding--4057a";
export var cPaddingBottom = "FaqSchemaSection-module--c-padding-bottom--c983d";
export var cPaddingTop = "FaqSchemaSection-module--c-padding-top--ce93a";
export var codeBox = "FaqSchemaSection-module--codeBox--3c2a6";
export var content = "FaqSchemaSection-module--content--e9df9";
export var copyButtonText = "FaqSchemaSection-module--copyButtonText--cfac3";
export var date = "FaqSchemaSection-module--date--a2b38";
export var deleteBtn = "FaqSchemaSection-module--deleteBtn--ea652";
export var disabled = "FaqSchemaSection-module--disabled--bcdd5";
export var ellipsis = "FaqSchemaSection-module--ellipsis--701b5";
export var faqHeader = "FaqSchemaSection-module--faqHeader--23c20";
export var faqItem = "FaqSchemaSection-module--faqItem--69012";
export var featuredSection = "FaqSchemaSection-module--featuredSection--a9fc1";
export var form = "FaqSchemaSection-module--form--4be9d";
export var globalSpacing = "FaqSchemaSection-module--global-spacing--6fe8a";
export var globalSpacingBottom = "FaqSchemaSection-module--global-spacing-bottom--fd969";
export var globalSpacingTop = "FaqSchemaSection-module--global-spacing-top--4a363";
export var image = "FaqSchemaSection-module--image--9600e";
export var imageWrapper = "FaqSchemaSection-module--imageWrapper--62d18";
export var index = "FaqSchemaSection-module--index--c031d";
export var listItem = "FaqSchemaSection-module--listItem--750ee";
export var maxWidth = "FaqSchemaSection-module--max-width--cbd98";
export var navButton = "FaqSchemaSection-module--navButton--f0bff";
export var pagination = "FaqSchemaSection-module--pagination--13a5c";
export var para = "FaqSchemaSection-module--para--ab0cb";
export var section = "FaqSchemaSection-module--section--406a9";
export var styleTick = "FaqSchemaSection-module--styleTick--d5cca";
export var subtitle = "FaqSchemaSection-module--subtitle--1c1a1";
export var tag = "FaqSchemaSection-module--tag--8e813";
export var tagWrapper = "FaqSchemaSection-module--tagWrapper--615b4";
export var title = "FaqSchemaSection-module--title--5e55d";
export var wrapper = "FaqSchemaSection-module--wrapper--3ee21";